import classNames from "classnames";
import NumberFormat from "react-number-format";
import { getInputClasses, InputSize } from "../../helpers/form";

interface MonetaryInputProps {
    value?: number;
    onChange: (value: number | undefined) => void;
    className?: string;
    showCurrencySymbolIfEmpty?: boolean;
    allowNegative?: boolean;
    size?: InputSize;
    onBlur?: () => void;
}

export const MonetaryInput: React.FC<MonetaryInputProps> = ({
    value,
    onChange,
    className,
    showCurrencySymbolIfEmpty,
    allowNegative,
    size,
    onBlur,
}) => (
    <NumberFormat
        value={value}
        onValueChange={(v) => onChange(v.floatValue)}
        prefix={value || showCurrencySymbolIfEmpty ? "$" : ""}
        decimalScale={2}
        fixedDecimalScale={value !== undefined}
        allowEmptyFormatting
        thousandSeparator
        allowNegative={allowNegative}
        className={classNames(getInputClasses(size), className)}
        onBlur={onBlur}
    />
);
